import PropTypes from 'prop-types';

import Occupants from 'components/Occupants';
import SummaryItem from '../SummaryItem';
import { MainText } from '../primitives';

const OccupantsInfo = ({ numberOfAdults, numberOfChildren, numberOfInfants }) => (
  <SummaryItem icon="person" label="Guests">
    <MainText>
      <Occupants numberOfAdults={numberOfAdults} numberOfChildren={numberOfChildren} numberOfInfants={numberOfInfants} />
    </MainText>
  </SummaryItem>
);

OccupantsInfo.propTypes = {
  numberOfAdults: PropTypes.number.isRequired,
  numberOfChildren: PropTypes.number.isRequired,
  numberOfInfants: PropTypes.number.isRequired,
};

export default OccupantsInfo;
